export const AUTH_BANNER_CONFIG = {
  already_used: {
    variant: "info",
    title: "Already Activated",
    message: "Your account has already been activated. Please log in to continue.",
  },
  expired: {
    variant: "warning",
    title: "Link Expired",
    message: "Your activation link has expired. Request a new one below.",
  },
  invalid: {
    variant: "error",
    title: "Invalid Link",
    message: "Your activation link is invalid or missing. Request a new one below.",
  },
  pin_challenge_expired: {
    variant: "warning",
    title: "Session Expired",
    message: "Your PIN verification session has expired. Please log in again.",
  },
  pin_changed: {
    variant: "success",
    title: "PIN Changed",
    message: "PIN changed successfully. Please log in with your new PIN.",
  },
  pin_reset_expired: {
    variant: "warning",
    title: "Link Expired",
    message: "Your PIN reset link has expired. Request a new one below.",
  },
  pin_reset_invalid: {
    variant: "error",
    title: "Invalid Link",
    message: "Your PIN reset link is invalid or missing. Request a new one below.",
  },
  pin_reset_already_used: {
    variant: "info",
    title: "Link Already Used",
    message: "This PIN reset link has already been used. Please log in to continue.",
  },
};
